import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
const locations = ['Midland', 'Saginaw', 'Caro', 'Bridgeport', 'Hemlock', 'Bay City'];
export function LocationContactSelector() {
  const [selectedLocation, setSelectedLocation] = useState<string>('');
  return <section className="py-16 bg-slate-50 border-y border-slate-200" data-id="element-84">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="text-center mb-10" data-id="element-86">
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-87">
            Location-Specific Contact
          </h2>
          <p className="text-slate-600" data-id="element-88">
            Select a location to view contact details for that school.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-lg overflow-hidden" data-id="element-89">
          {/* Location Selector */}
          <div className="bg-[#1a2332] p-6 text-white" data-id="element-90">
            <h3 className="text-xl font-bold mb-4 text-center" data-id="element-91">
              Select a Location
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-92">
              {locations.map(loc => <button key={loc} onClick={() => setSelectedLocation(loc)} className={`px-4 py-3 rounded-lg font-medium transition-colors ${selectedLocation === loc ? 'bg-[#dc2626] text-white' : 'bg-white/10 text-white hover:bg-white/20'}`} data-id="element-93">
                  {loc}
                </button>)}
            </div>
          </div>

          {/* Contact Details Placeholder */}
          <div className="p-8 md:p-12 min-h-[300px] flex flex-col items-center justify-center" data-id="element-94">
            {selectedLocation ? <div className="text-center max-w-lg w-full animate-in fade-in duration-300" data-id="element-95">
                <div className="h-16 w-16 bg-slate-100 rounded-full flex items-center justify-center mb-6 mx-auto text-[#dc2626]" data-id="element-96">
                  <MapPin className="h-8 w-8" data-id="element-97" />
                </div>
                <h3 className="text-2xl font-bold text-[#1a2332] mb-6" data-id="element-98">
                  {selectedLocation} Location
                </h3>

                <div className="space-y-4 mb-8" data-id="element-99">
                  <div className="flex items-center justify-center p-4 bg-slate-50 rounded-lg border-2 border-dashed border-slate-300" data-id="element-100">
                    <MapPin className="h-5 w-5 text-slate-400 mr-3" data-id="element-101" />
                    <span className="text-slate-500 font-medium" data-id="element-102">
                      Address Placeholder
                    </span>
                  </div>

                  <div className="flex items-center justify-center p-4 bg-slate-50 rounded-lg border-2 border-dashed border-slate-300" data-id="element-103">
                    <Phone className="h-5 w-5 text-slate-400 mr-3" data-id="element-104" />
                    <span className="text-slate-500 font-medium" data-id="element-105">
                      Phone Number Placeholder
                    </span>
                  </div>

                  <div className="flex items-center justify-center p-4 bg-slate-50 rounded-lg border-2 border-dashed border-slate-300" data-id="element-106">
                    <Mail className="h-5 w-5 text-slate-400 mr-3" data-id="element-107" />
                    <span className="text-slate-500 font-medium" data-id="element-108">
                      Email Placeholder
                    </span>
                  </div>

                  <div className="flex items-center justify-center p-4 bg-slate-50 rounded-lg border-2 border-dashed border-slate-300" data-id="element-109">
                    <Clock className="h-5 w-5 text-slate-400 mr-3" data-id="element-110" />
                    <span className="text-slate-500 font-medium" data-id="element-111">
                      Hours Placeholder
                    </span>
                  </div>
                </div>

                <p className="text-sm text-slate-500 italic" data-id="element-112">
                  Location contact details will appear here
                </p>
              </div> : <div className="text-center max-w-md" data-id="element-113">
                <div className="h-16 w-16 bg-slate-200 rounded-full flex items-center justify-center mb-6 mx-auto text-slate-400" data-id="element-114">
                  <MapPin className="h-8 w-8" data-id="element-115" />
                </div>
                <h3 className="text-xl font-medium text-slate-700 mb-2" data-id="element-116">
                  Select a Location
                </h3>
                <p className="text-slate-500" data-id="element-117">
                  Choose a location above to view contact details for that
                  school.
                </p>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}